import qs from "query-string";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { vendorGetCheckpointLocation } from "@services/checkpoint.service";
import { getValue } from "@utils/lodash";
import DatePicker from "react-date-picker";
import "./uploaded.scss";
import moment from "moment";
import PaginationPage from "@components/pagination/pagination";
import { toast } from "react-toastify";
import { QueryRequestHelper } from "@_common/query-request-helper";
import CalenderDropdown from "@_common/CalenderDropdown";
import VerifiedSvgComponent from "../../assets/svg-components/verified";
import ReactTooltip from "react-tooltip";
import { debounceSearch, getEncodedKey } from "@_common/text-helper";
import SearchHeader from "@components/common/SearchHeader";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { getManageAuditScoreFilter } from "@services/reports.service";
import React from "react";

interface ICheckPointLocationsProps {}

const CheckPointLocations: React.FunctionComponent<
  ICheckPointLocationsProps
> = (props) => {
  let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [info, setInfo] = useState({});
  const [isFilterVisible, setFilterVisibility] = useState(false);
  const [request, setRequest] = useState<any>({
    state_id: "",
    city_id: "",
    // region_id: "",
    group_id: "",
    location_id: "",
    submit_status: "",
    // vendor_id: "",
    // audit_type: "",
  });

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0) {
      getData();
      setDate(new Date());
      getGroupsList("", "");
      getStatesList("", "", "");
      getCitiesList("", "", "", "");
      getLocationsList("", "", "", "", "");
    }
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0) {
      getData();
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }

      getGroupsList("", "");
      getStatesList("", "", "");
      getCitiesList("", "", "", "");
      getLocationsList("", "", "", "", "");
    }
  }, [window.location.href]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let user = JSON.parse(getValue(localStorage, `user`, {}));
    let vendor_id = getValue(user, `vendor.id`, "");
    let user_id = getValue(user, `id`, "");
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : 100,
      search_text: params.search_text,
      status: params.status,
      sort_by: params.sort_by,
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      vendor_id: vendor_id,
      user_id: user_id,
      group_id: params.group_id,
      location_id: params.location_id,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      status_is_submitted: params.is_submitted === "Submitted",
      status_is_not_submitted: params.submit_status === "Not_Submitted",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      let resp = await vendorGetCheckpointLocation(queryRequest);
      if (resp) {
        setIsLoading(false);
        setLocations(getValue(resp, `data.vendors_checkpoint`, []));
        const vendorsCheckpoint = getValue(resp, `data.vendors_checkpoint`, []);
        const releaseInfoArray = vendorsCheckpoint.map(
          (item: any) => item.releaseInfo
        );
        setInfo(releaseInfoArray);

        // setInfo(getValue(resp, `data.vendors_checkpoint.releaseInfo`, {}));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: page_no,
    };
    const queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      limit: limit,
      page_no: 1,
    };
    const queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleSearch = async (e: any) => {
    if (e.target.value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      params.search_text = e.target.value;
      let queryRequest = qs.stringify(params);
      navigate(`${window.location.pathname}?${queryRequest}`);
      if (!e.target.value) {
        getData();
      }
    } else {
      toggleSearchClose();
    }
  };
  const debouncedSearch = useMemo(() => debounceSearch(handleSearch, 500), []);

  const handleChangeSearch = (e: any) => {
    setSearchInput(e.target.value);
    debouncedSearch(e);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Date section                             */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        date: dates,
      };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  const handleNavigate = (bodyObj: object) => {
    navigate(
      `/checkpoint/details/${getValue(bodyObj, `location_id`, "")}/${moment(
        date
      ).format("YYYY-MM-DD")}/${getValue(bodyObj, `location_name`, "")}/${
        getValue(bodyObj, `releaseInfo.listEnable`, false) ? "1" : "0"
      }/${
        getValue(bodyObj, `releaseInfo.is_audit_completed`, false)
          ? "audit-completed"
          : "audit-pending"
      }/${getValue(bodyObj, `total_pending_task.score`, "")}`
    );
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const status = ["green-color", "blue-color", "black-color"];
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  let dates = params.date ? new Date(params.date) : date ? date : new Date();
  var firstDay = new Date(dates.getFullYear(), dates.getMonth(), 1);
  var lastDay = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
  // console.log(getEncodedKey('documents/Workman-register-TR-Sept-24-1730892906517.pdf'),"----")
  // console.log(getEncodedKey("https://storage.lexcare.ai/client-assets-private/documents/Workman-register-TR-Sept-24-1730892906517.pdf"),"----")

  /* -------------------------------------------------------------------------- */
  /*                    smart Filter API section                                */
  /* -------------------------------------------------------------------------- */
  const [groupsList, setGroupsList] = useState([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const getGroupsList = async (
    search_text: string,
    // region_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        type: "GROUP",
        search_text: search_text,
        group_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };
      setGroupLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setGroupsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            label: getValue(item, `group_name`, ""),
            value: getValue(item, `group_name`, ""),
          }))
        );
        setGroupLoading(false);
      } else {
        setGroupLoading(false);
      }
    } catch (error) {
      setGroupLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   group_id: null,
      // });
      //   getLocationsList("", "", "");
      //   setlocationsList([]);
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const getStatesList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        type: "STATE",
        search_text: search_text,
        state_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };

      setStateLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setStateList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `state_id`, ""),
            label: getValue(item, `state_name`, ""),
            value: getValue(item, `state_name`, ""),
          }))
        );
        setStateLoading(false);
      } else {
        setStateLoading(false);
      }
    } catch (error) {
      setStateLoading(false);
    }
  };

  const [cityList, setCityList] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const getCitiesList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    state_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        type: "CITY",
        search_text: search_text,
        state_id: state_id,
        city_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };

      setCityLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setCityList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `city_id`, ""),
            label: getValue(item, `city_name`, ""),
            value: getValue(item, `city_name`, ""),
          }))
        );
        setCityLoading(false);
      } else {
        setCityLoading(false);
      }
    } catch (error) {
      setCityLoading(false);
    }
  };

  const [locationsList, setlocationsList] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const getLocationsList = async (
    search_text: string,
    // region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        // region_id: region_id,
        group_id: group_id,
        type: "LOCATION",
        search_text: search_text,
        state_id: state_id,
        city_id: city_id,
        location_id: id,
        is_redirect: true,
        userType: "VENDOR",
      };
      setLocationLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setlocationsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `location_id`, ""),
            label: getValue(item, `location_name`, ""),
            value: getValue(item, `location_name`, ""),
          }))
        );
        setLocationLoading(false);
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }
  };

  let state_ID =
    getValue(stateList, `length`, 0) > 0 &&
    stateList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );

  let city_ID =
    getValue(cityList, `length`, 0) > 0 &&
    cityList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `city_id`, "")
    );

  let group_ID =
    getValue(groupsList, `length`, 0) > 0 &&
    groupsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `group_id`, "")
    );

  let location_ID =
    getValue(locationsList, `length`, 0) > 0 &&
    locationsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, "")
    );

  const handleRemoveFilter = (name: string) => {
    if (name === "region_id") {
      setRequest({
        ...request,
        // region_id: "",
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", "");
      getStatesList("", "", "");
      getCitiesList("", "", "", "");
      getLocationsList("", "", "", "", "");

      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
    }
    if (name === "group_id") {
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", "");
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
    }

    if (name === "state_id") {
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getStatesList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        ""
      );
      setCityList([]);
      setlocationsList([]);
    }

    if (name === "city_id") {
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getCitiesList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        ""
      );
      setlocationsList([]);
    }

    if (name === "location_id") {
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      getLocationsList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        ""
      );
    }

    // getRegionsList("", "");
    // getGroupsList("", "", "");
    // getStatesList("", "", "", "");
    // getCitiesList("", "", "", "", "");
    // getLocationsList("","","","","","");
    // getVendorList("","","","","","","");
    // getAuditTypeList("","","","","","","","");
  };

  const handleSelectFilter = (id: any, name: string) => {
    // if (name === "region_id") {
    //   getGroupsList("", id);
    //   setRequest({
    //     ...request,
    //     group_id: "",
    //     state_id: "",
    //     city_id: "",
    //     location_id: "",
    //     vendor_id: "",
    //     audit_type: "",
    //   });
    //   setGroupsList([]);
    //   setStateList([]);
    //   setCityList([]);
    //   setlocationsList([]);
    //   setvendorsList([]);
    //   setAuditTypeList([]);
    // }
    if (name === "group_id") {
      getStatesList("", id, "");
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
    }

    if (name === "state_id") {
      getCitiesList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        // vendor_id: "",
        audit_type: "",
      });
      setCityList([]);
      setlocationsList([]);
    }

    if (name === "city_id") {
      getLocationsList(
        "",
        // getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setlocationsList([]);
    }

    // if (name === "location_id") {
    //   getVendorList(
    //     "",
    //     // getValue(request, `region_id`, ""),
    //     getValue(request, `group_id`, ""),
    //     getValue(request, `state_id`, ""),
    //     getValue(request, `city_id`, ""),
    //     id,
    //     ""
    //   );
    //   setRequest({
    //     ...request,
    //     vendor_id: "",
    //     audit_type: "",
    //   });
    //   setvendorsList([]);
    //   setAuditTypeList([]);
    // }

    //   if (name === "location_id") {
    // 	getAuditTypeList(
    // 	  "",
    // 	  // getValue(request, `region_id`, ""),
    // 	  getValue(request, `group_id`, ""),
    // 	  getValue(request, `state_id`, ""),
    // 	  getValue(request, `city_id`, ""),
    // 	  // getValue(request, `location_id`, ""),
    // 	  id,
    // 	  ""
    // 	);
    // 	setRequest({
    // 	  ...request,
    // 	  audit_type: "",
    // 	});
    // 	setAuditTypeList([]);
    //   }

    setRequest({
      ...request,
      [name]: id,
    });
  };

  const handleSubmitSmartFilter = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      city_id: getValue(request, `city_id`, ""),
      // region_id: getValue(request, `region_id`, ""),
      group_id: getValue(request, `group_id`, ""),
      location_id: getValue(request, `location_id`, ""),
      // vendor_id: getValue(request, `vendor_id`, ""),
      audit_type: getValue(request, `audit_type`, ""),
      is_submitted: getValue(request, `submit_status`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    // handleFilter();
    setFilterVisibility(false);
  };

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
      date: getValue(params, `date`, ""),
      view_type: params.view_type, // Preserve view_type
    };
    setRequest({
      ...request,
      state_id: "",
      city_id: "",
      // region_id: "",
      group_id: "",
      location_id: "",
      // vendor_id: "",
      audit_type: "",
      submit_status: "",
    });
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    // setFilterVisibility(false);
  };

  const [submitStatusList] = useState([
    { value: "Submitted", label: "Submitted" },
    { value: "Not_Submitted", label: "Not Submitted" },
  ]);

  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  const handleStatusChange = (name: string, value: string) => {
    setRequest((prevRequest: any) => ({
      ...prevRequest,
      [name]: value,
    }));
  };

  const averageAuditScore = React.useMemo(() => {
    if (!locations || locations.length === 0) return 0;

    const validScores = locations
      .map((item: any) =>
        parseFloat(getValue(item, "total_pending_task.score", 0))
      )
      .filter((score) => !isNaN(score));

    if (validScores.length === 0) return 0;

    const total = validScores.reduce((sum, val) => sum + val, 0);
    return (total / validScores.length).toFixed(2);
  }, [locations]);

  return (
    <DashboardLayout>
      <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
        <h4 className="dashbaord-wrapper__header-title">Audit Checkpoints </h4>
        <h4>
          {" "}
          {`Wage Period : ${
            firstDay ? moment(firstDay).format("DD MMM YYYY") : ""
          } - ${lastDay ? moment(lastDay).format("DD MMM YYYY") : ""}`}
        </h4>
        <div className="d-flex align-items-center">
          {/* <DatePicker
						onChange={setDate}
						value={date}
						format="MMM yyyy"
						disableCalendar={true}
						yearAriaLabel={"yyyy"}
					/>
					<button className="header-btn" onClick={handleSubmitDate}>
						Apply
					</button> */}
          <CalenderDropdown
            onChange={setDate}
            value={date}
            handleSubmitDate={handleSubmitDate}
          />
          <div className="header-searchbar-wrapper ms-2">
            <SearchHeader
              addVisible={false}
              searchVisible={false}
              smartFilter={true}
              setFilterFormVisibility={() => {
                setFilterVisibility(!isFilterVisible);
              }}
              isFilterVisible={false}
            />
          </div>
        </div>
      </div>
      <div className="sub-header d-flex align-items-center justify-content-between">
        {/* {getValue(info, `isError`, "") ? (
					<div className="checkpoints-timer-wrapper-error m-2 d-flex align-items-center">
						<img src="/images/red-awesome.svg" className="img-fluid" />
						<p className="mx-2">{getValue(info, `msg`, "")}</p>
					</div>
				) : (
					<div className="checkpoints-timer-wrapper m-2 d-flex align-items-center">
						<img src="/images/purple-awesome.svg" className="img-fluid" />
						<p className="mx-2">
							{getValue(info, `days`, "")} {getValue(info, `msg`, "")}
						</p>
					</div>
				)} */}
        <div className="overall-score">
          <span className="overall-score__label">Overall Score</span>
          <span className="overall-score__value">{averageAuditScore}%</span>
        </div>

        <div className="checkpoints-search-location-wrapper">
          <div className="form-group m-0">
            <input
              type="text"
              placeholder="Search Location"
              className="search-location__form-control form-control"
              value={search_text}
              onChange={handleChangeSearch}
            />
            <img src="/images/search.svg" className="img-fluid" alt="" />
          </div>
        </div>
      </div>

      <section className="uploaded-wrapper">
        {/* {isFilterVisible && ( */}
        <div
          className={`filter-slidder-wrapper  ${
            isFilterVisible ? "filter-slidder-wrapper--active" : ""
          }`}
        >
          <div className="filter-form-wrappper w-100 active filter-form-legal-update">
            <div className="filter-form-wrappper__container">
              <div className="filter-header-wrapper d-flex align-items-center justify-content-between">
                <div className="filter-header-left-wrapper d-flex align-items-center">
                  <div className="filter-close-wrapper">
                    <img
                      src="/images/close-circle.svg"
                      className="img-fluid cursor-pointer"
                      onClick={() => {
                        setFilterVisibility(false);
                      }}
                    />
                  </div>
                  <div className="filter-title-wrapper">
                    <h6 className="filter-form-wrappper__title">Filter</h6>
                  </div>

                  <div className="filter-module-details-wrapper">
                    <div className="filter-module-name">Checkpoint</div>
                  </div>
                </div>

                <div className="filter-header-right-wrapper">
                  <div className="filter-form-wrappper__cta-wrapper p-0 d-flex">
                    <button
                      className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                      onClick={reset}
                    >
                      <div className="d-flex align-items-center mt--3">
                        Reset
                      </div>
                    </button>

                    <button
                      className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
                      onClick={() => {
                        setFilterVisibility(false);
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                      onClick={handleSubmitSmartFilter}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>

              <div className="filter-body-wrapper">
                <div className="filter-body-card">
                  <div className="filter-card-title">Filter By</div>

                  <div className="d-flex justify-content-between flex-column">
                    <div className="filter-form-wrappper__location">
                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label"
                          >
                            Account
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <SearchableDropdownSelect
                              placeholder={`Select Account`}
                              options={groupsList}
                              searchLoading={groupLoading}
                              handleChange={(val: any) =>
                                val
                                  ? getGroupsList(
                                      val,
                                      getValue(request, `group_id`, "")
                                      // ""
                                    )
                                  : handleRemoveFilter("group_id")
                              }
                              handleClick={(e: any) =>
                                handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "group_id"
                                )
                              }
                              // value={group_ID}
                              value={
                                Array.isArray(group_ID) && group_ID.length > 0
                                  ? group_ID[0]
                                  : ""
                              }
                              label="label"
                              id="id"
                              name={"group_id"}
                            />
                          </div>
                        </div>

                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label"
                          >
                            State
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <SearchableDropdownSelect
                              placeholder={`Choose State`}
                              options={stateList}
                              searchLoading={stateLoading}
                              handleChange={(val: any) =>
                                val
                                  ? getStatesList(
                                      val,
                                      // getValue(request, `region_id`, ""),
                                      getValue(request, `group_id`, ""),
                                      // getValue(props, `request.state_id`, ""),
                                      ""
                                    )
                                  : handleRemoveFilter("state_id")
                              }
                              handleClick={(e: any) =>
                                handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "state_id"
                                )
                              }
                              value={
                                Array.isArray(state_ID) && state_ID.length > 0
                                  ? state_ID[0]
                                  : ""
                              }
                              label="label"
                              id="id"
                              name={"state_id"}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label"
                          >
                            City
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <SearchableDropdownSelect
                              placeholder={`Choose City`}
                              options={cityList}
                              searchLoading={cityLoading}
                              handleChange={(val: any) =>
                                val
                                  ? getCitiesList(
                                      val,
                                      // getValue(request, `region_id`, ""),
                                      getValue(request, `group_id`, ""),
                                      getValue(request, `state_id`, ""),
                                      // getValue(props, `request.city_id`, ""),
                                      ""
                                    )
                                  : handleRemoveFilter("city_id")
                              }
                              handleClick={(e: any) =>
                                handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "city_id"
                                )
                              }
                              // value={getValue(props, `city_ID[${0}]`, "")}
                              value={
                                Array.isArray(city_ID) && city_ID.length > 0
                                  ? city_ID[0]
                                  : ""
                              }
                              label="label"
                              id="id"
                              name={"city_id"}
                            />
                          </div>
                        </div>

                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label"
                          >
                            Site
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <SearchableDropdownSelect
                              placeholder={`Select Site`}
                              options={locationsList}
                              searchLoading={locationLoading}
                              handleChange={(val: any) =>
                                val
                                  ? getLocationsList(
                                      val,
                                      // getValue(request, `region_id`, ""),
                                      getValue(request, `group_id`, ""),
                                      getValue(request, `state_id`, ""),
                                      getValue(request, `city_id`, ""),
                                      ""
                                    )
                                  : handleRemoveFilter("location_id")
                              }
                              handleClick={(e: any) =>
                                handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "location_id"
                                )
                              }
                              // value={location_ID}
                              value={
                                Array.isArray(location_ID) &&
                                location_ID.length > 0
                                  ? location_ID[0]
                                  : ""
                              }
                              label="label"
                              id="id"
                              name={"location_id"}
                              // removeClose
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label"
                          >
                            Status
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <SearchableDropdownSelect
                              placeholder={"Choose Status"}
                              options={submitStatusList}
                              handleChange={(e: any) =>
                                handleStatusChange(
                                  "submit_status",
                                  getValue(e, "value", "")
                                )
                              }
                              handleClick={(e: any) =>
                                handleStatusChange(
                                  "submit_status",
                                  getValue(e, "value", "")
                                )
                              }
                              value={
                                getValue(submitStatusList, "length", 0) > 0 &&
                                submitStatusList.find(
                                  (item: object) =>
                                    getValue(item, "value", "") ===
                                    getValue(request, "submit_status", "")
                                )
                              }
                              // className="form-control"
                              name="compliance_status"
                              label="label"
                              id="id"
                            />
                          </div>
                        </div>

                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="filter-form-wrappper__cta-wrapper">
              <button
                className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                onClick={handleSubmitSmartFilter}
              >
                Search
              </button>
              <button
                className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                onClick={reset}
              >
                Reset
              </button>
            </div>
            {/* <AddFilterNew /> */}
          </div>
        </div>
        {/* )} */}

        {isLoading ? (
          <Loader />
        ) : getValue(locations, `length`, 0) > 0 ? (
          <>
            <table className="uploaded-wrapper__table w-100">
              <thead>
                <tr>
                  <th></th>
                  <th style={{ width: "120px" }}>
                    <div className="uploaded-wrapper__table-header-details">
                      <h5 className="uploaded-wrapper__table-header-title">
                        Cutoff-Date
                      </h5>
                      <p className="uploaded-wrapper__table-header-text">
                        Start Date
                      </p>
                    </div>
                  </th>
                  <th style={{ width: "150px", maxWidth: "200px" }}>
                    <div className="uploaded-wrapper__table-header-details">
                      <h5 className="uploaded-wrapper__table-header-title">
                        Site Name
                      </h5>
                      <p className="uploaded-wrapper__table-header-text">
                        Site Code
                      </p>
                    </div>
                  </th>
                  <th style={{ width: "170px", maxWidth: "170px" }}>
                    <div className="uploaded-wrapper__table-header-details">
                      <h5 className="uploaded-wrapper__table-header-title">
                        Account Name
                      </h5>
                      <p className="uploaded-wrapper__table-header-text">
                        Entity Name
                      </p>
                    </div>
                  </th>
                  <th>
                    <div
                      className="uploaded-wrapper__table-header-details"
                      style={{ width: "120px", maxWidth: "120px" }}
                    >
                      <h5 className="uploaded-wrapper__table-header-title">
                        State
                      </h5>
                      <p className="uploaded-wrapper__table-header-text">
                        City
                      </p>
                    </div>
                  </th>
                  {/* <th style={{ width: "200px" }}>
                    <div className="uploaded-wrapper__table-header-details">
                      <h5 className="uploaded-wrapper__table-header-title">
                        Total Tasks
                      </h5>
                      <p className="uploaded-wrapper__table-header-text">
                        (Completed / Assigned Tasks)
                      </p>
                    </div>
                  </th> */}

                  {/* <th>
										<div className="uploaded-wrapper__table-header-details">
											<h5 className="uploaded-wrapper__table-header-title">
												Partially Complied
											</h5>
											<p className="uploaded-wrapper__table-header-text">
												Not Applicable
											</p>
										</div>
									</th> */}
                  <th>
                    <div className="uploaded-wrapper__table-header-details">
                      <h5 className="uploaded-wrapper__table-header-title">
                        {/* Submitted */}
                        Uploaded
                      </h5>
                    </div>
                  </th>

                  <th>
                    <div className="uploaded-wrapper__table-header-details">
                      <h5 className="uploaded-wrapper__table-header-title">
                        Not Submitted
                      </h5>
                    </div>
                  </th>

                  <th style={{ width: "120px" }}>
                    <div className="uploaded-wrapper__table-header-details">
                      <h5 className="uploaded-wrapper__table-header-title">
                        Audit Score
                      </h5>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {locations.map((bodyObj: object, index: number) => {
                  const startDate = moment(getValue(bodyObj, "start_date", ""));
                  const cutoffDate = moment(
                    getValue(bodyObj, "cutoff_date", "")
                  );
                  const currentDate = moment();

                  // Determine bubble color based on conditions
                  let bubbleImage = ""; // Default bubble image
                  let statusMessage = ""; // Default status message
                  let statusClass = "";
                  if (currentDate.isBefore(startDate, "day")) {
                    bubbleImage = "/images/bubble-green.svg"; // Green if current date is before the start date
                    statusMessage = "Yet to Start"; // Status if the current date is before the start date
                    statusClass = "yet-to-start";
                  } else if (
                    currentDate.isSameOrAfter(startDate, "day") &&
                    currentDate.isSameOrBefore(cutoffDate, "day")
                  ) {
                    bubbleImage = "/images/bubble.svg"; // Orange if current date is between start and cutoff dates
                    statusMessage = "Upload Open"; // Status if within the start and cutoff date range
                    statusClass = "open-to-upload";
                  } else if (currentDate.isAfter(cutoffDate, "day")) {
                    bubbleImage = "/images/bubble-red.svg"; // Red if current date is after the cutoff date
                    statusMessage = "Upload Close"; // Status if the cutoff date has passed
                    statusClass = "window-closed";
                  }

                  // const handleClick = () => {
                  // 	if (currentDate.isSameOrAfter(startDate, 'day') && currentDate.isSameOrBefore(cutoffDate, 'day')) {
                  // 		handleNavigate(bodyObj);
                  // 	}
                  // };
                  // const handleClick = () => {
                  // 	const endOfCurrentMonth = moment().endOf('month');

                  // 	if (startDate.isAfter(endOfCurrentMonth) && cutoffDate.isAfter(endOfCurrentMonth)) {
                  // 		// If both dates are in the future (after the current month), do not navigate
                  // 		return;
                  // 	}

                  // 	// Allow clicking on all other dates
                  // 	handleNavigate(bodyObj);
                  // };

                  const handleClick = () => {
                    const currentDate = moment(); // today's date

                    if (
                      // Navigate if the range includes today or is in the past
                      (startDate.isSameOrBefore(currentDate, "day") &&
                        cutoffDate.isSameOrAfter(currentDate, "day")) ||
                      (startDate.isBefore(currentDate, "day") &&
                        cutoffDate.isBefore(currentDate, "day"))
                    ) {
                      handleNavigate(bodyObj);
                    }
                    // No else block needed; if the condition is not met, navigation is blocked.
                  };

                  return (
                    <tr
                      key={index}
                      // onClick={() => handleNavigate(bodyObj)}
                      onClick={handleClick}
                    >
                      <td className="text-center" width={"5%"}>
                        <div>
                          {/* <img src="/images/bubble.svg" className="img-fluid" /> */}
                          {/* <img src={bubbleImage} className="img-fluid" /> */}
                          <div className={statusClass}>{statusMessage}</div>
                        </div>
                      </td>
                      <td>
                        <div className="uploaded-wrapper__table-body-details">
                          <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--`}
                          >
                            {moment(
                              getValue(bodyObj, `cutoff_date`, "")
                            ).format("DD MMM YYYY")}

                            {getValue(
                              bodyObj,
                              `releaseInfo.is_audit_completed`,
                              false
                            ) ? (
                              <span
                                className="ms-2"
                                data-tip
                                data-for="happyFace1"
                              >
                                <VerifiedSvgComponent />
                              </span>
                            ) : (
                              ""
                            )}
                            <ReactTooltip id="happyFace1">
                              <span>Audit Completed</span>
                            </ReactTooltip>
                          </h5>
                          <p>
                            {moment(getValue(bodyObj, `start_date`, "")).format(
                              "DD MMM YYYY"
                            )}
                          </p>
                        </div>
                      </td>
                      <td
                        key={index}
                        style={{ width: "200px", maxWidth: "200px" }}
                      >
                        {/* <NavLink
													to={`/checkpoint/details/${getValue(
														bodyObj,
														`location_id`,
														""
													)}/${moment(date).format("YYYY-MM-DD")}/${getValue(
														bodyObj,
														`location_code`,
														""
													)}/${getValue(bodyObj, `checkpoint_id`, "")}/${
														getValue(bodyObj, `releaseInfo.listEnable`, false) ? "1" : "0"
													}`}
												> */}
                        <div className="uploaded-wrapper__table-body-details">
                          <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                            data-tip
                            data-for={`location_name${index}`}
                          >
                            {getValue(bodyObj, `location_name`, "")}
                          </h5>
                          <p data-tip data-for={`location_code${index}`}>
                            {getValue(bodyObj, `location_code`, "")}
                          </p>

                          <ReactTooltip id={`location_name${index}`}>
                            <span>
                              {getValue(bodyObj, `location_name`, "")}
                            </span>
                          </ReactTooltip>

                          <ReactTooltip id={`location_code${index}`}>
                            <span>
                              {getValue(bodyObj, `location_code`, "")}
                            </span>
                          </ReactTooltip>
                        </div>
                        {/* </NavLink> */}
                      </td>
                      <td style={{ width: "170px", maxWidth: "170px" }}>
                        <div className="uploaded-wrapper__table-body-details">
                          <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                            data-tip
                            data-for={`group_name${index}`}
                          >
                            {getValue(bodyObj, `group_name`, "")}
                          </h5>
                          <p data-tip data-for={`entity_name${index}`}>
                            {getValue(bodyObj, `entity_name`, "")}
                          </p>

                          <ReactTooltip id={`group_name${index}`}>
                            <span>{getValue(bodyObj, `group_name`, "")}</span>
                          </ReactTooltip>

                          <ReactTooltip id={`entity_name${index}`}>
                            <span>{getValue(bodyObj, `entity_name`, "")}</span>
                          </ReactTooltip>
                        </div>
                      </td>
                      <td style={{ width: "120px", maxWidth: "120px" }}>
                        <div className="uploaded-wrapper__table-body-details">
                          <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                          >
                            {getValue(bodyObj, `location_state`, "")}
                          </h5>
                          <p>{getValue(bodyObj, `city_name`, "")}</p>
                        </div>
                      </td>
                      {/* <td>
												<div className="uploaded-wrapper__table-body-details">
													<h5
														className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
													>
														<div className="total-task-holder">
															{getValue(bodyObj, `total_pending_task.pending_count`, "")} / {getValue(bodyObj, `total_pending_task.total_count`, "")}
														</div>
													</h5>
												</div>
											</td> */}

                      <td className="d-none">
                        <div className="uploaded-wrapper__table-body-details d-none">
                          {/* <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                          >
                            <div className="total-task-count">
                              <span
                                // className={`completed-tasks ${
                                // 	getValue(bodyObj, 'total_pending_task.pending_count', '') === 0
                                // 	? 'zero'
                                // 	: getValue(bodyObj, 'total_pending_task.pending_count', '') ===
                                // 		getValue(bodyObj, 'total_pending_task.total_count', '')
                                // 	? 'full'
                                // 	: ''
                                // }`}
                                className={`completed-tasks ${
                                  getValue(
                                    bodyObj,
                                    "total_pending_task.pending_count",
                                    ""
                                  ) === "0"
                                    ? "full" // Green when all tasks are completed
                                    : getValue(
                                        bodyObj,
                                        "total_pending_task.pending_count",
                                        ""
                                      ) ===
                                      getValue(
                                        bodyObj,
                                        "total_pending_task.total_count",
                                        ""
                                      )
                                    ? "zero" // Red when all tasks are pending
                                    : ""
                                }`}
                              >
                                {getValue(
                                  bodyObj,
                                  "total_pending_task.completed_count",
                                  ""
                                )}
                                /
                                {getValue(
                                  bodyObj,
                                  "total_pending_task.total_count",
                                  ""
                                )}
                              </span>
                            </div>
                          </h5> */}
                          <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                          >
                            <div className="total-task-count">
                              <span
                                // className={`completed-tasks ${
                                // 	getValue(bodyObj, 'total_pending_task.pending_count', '') === 0
                                // 	? 'zero'
                                // 	: getValue(bodyObj, 'total_pending_task.pending_count', '') ===
                                // 		getValue(bodyObj, 'total_pending_task.total_count', '')
                                // 	? 'full'
                                // 	: ''
                                // }`}
                                className={`completed-tasks ${
                                  getValue(
                                    bodyObj,
                                    "total_pending_task.submitted_count",
                                    ""
                                  ) === "0"
                                    ? "full" // Green when all tasks are completed
                                    : getValue(
                                        bodyObj,
                                        "total_pending_task.submitted_count",
                                        ""
                                      ) ===
                                      getValue(
                                        bodyObj,
                                        "total_pending_task.not_submitted_count",
                                        ""
                                      )
                                    ? "zero" // Red when all tasks are pending
                                    : ""
                                }`}
                              >
                                {getValue(
                                  bodyObj,
                                  "total_pending_task.submitted_count",
                                  ""
                                )}
                                /
                                {getValue(
                                  bodyObj,
                                  "total_pending_task.not_submitted_count",
                                  ""
                                )}
                              </span>
                            </div>
                          </h5>
                        </div>
                      </td>

                      <td>
                        <div className="uploaded-wrapper__table-body-details">
                          <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                          >
                            {getValue(
                              bodyObj,
                              `total_pending_task.submitted_count`,
                              ""
                            )}
                          </h5>
                        </div>
                      </td>

                      <td>
                        <div className="uploaded-wrapper__table-body-details">
                          <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                          >
                            {getValue(
                              bodyObj,
                              `total_pending_task.not_submitted_count`,
                              ""
                            )}
                          </h5>
                        </div>
                      </td>

                      <td>
                        <div className="uploaded-wrapper__table-body-details">
                          <h5
                            className={`uploaded-wrapper__table-title uploaded-wrapper__table-title--${status[3]}`}
                          >
                            {/* {getValue(bodyObj, `location_state`, "")} */}
                            {/* {getValue(bodyObj, `total_pending_task.score`, "")}% */}
                            {`${getValue(
                              bodyObj,
                              "total_pending_task.score",
                              ""
                            )}${
                              getValue(
                                bodyObj,
                                "releaseInfo.is_audit_completed",
                                false
                              )
                                ? "%"
                                : ""
                            }`}
                          </h5>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        ) : (
          <>{Object.keys(params).length !== 0 ? <Notfound /> : <Notfound />}</>
        )}
        <div className="d-flex justify-content-between">
          {/* {locations.length > 0 && (
						<img src="/images/profile-illustration.svg" className="img-fluid" />
					)} */}
          {totalCount > 10 ? (
            <PaginationPage
              totalCount={totalCount}
              limit={limit}
              pageNumber={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          ) : (
            ""
          )}
        </div>
      </section>
    </DashboardLayout>
  );
};

export default CheckPointLocations;
